// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recovery-shell {
  min-height: 100vh;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-family: var(--font-family-primary);
  font-size: var(--font-size-body-sm);
  line-height: 1.55;
}
.recovery-shell * {
  box-sizing: border-box;
}
.recovery-main {
  margin-left: 256px;
  min-width: 0;
}
.recovery-page {
  padding: var(--space-8);
  max-width: 1600px;
  margin: 0 auto;
  display: grid;
  gap: var(--space-6);
  min-width: 0;
}
.recovery-shell :is(h1, h2, h3, p) {
  margin: 0;
}
.recovery-shell h1 {
  font-size: 32px;
  line-height: 40px;
  letter-spacing: -0.48px;
  font-weight: var(--font-weight-semibold);
}
.recovery-shell h2 {
  font-size: var(--font-size-h4);
  font-weight: var(--font-weight-medium);
  line-height: 1.5;
}
.recovery-shell h3 {
  font-size: var(--font-size-body-md);
  font-weight: var(--font-weight-medium);
  line-height: 1.5;
}
.recovery-heading {
  display: grid;
  gap: var(--space-2);
}
.recovery-heading p,
.recovery-context,
.recovery-panel > p {
  color: var(--text-secondary);
}
.recovery-page a,
.recovery-modal a {
  color: var(--interactive-default);
  text-decoration: none;
}
.recovery-page a:hover,
.recovery-modal a:hover {
  text-decoration: underline;
}
.recovery-shell button {
  font: inherit;
  cursor: pointer;
}
.recovery-shell button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}
.recovery-shell :focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 3px;
}
.recovery-context {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-4);
  font-size: var(--font-size-caption-md);
}
.recovery-context > .quotation-figma-dropdown {
  max-width: 140px;
}
.recovery-stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-6);
}
.recovery-stat {
  border: 1px solid var(--border-default);
  border-radius: var(--radius-lg);
  padding: var(--space-6);
  background: var(--surface-primary);
  display: grid;
  gap: var(--space-3);
  min-height: 148px;
  align-content: start;
  min-width: 0;
}
.recovery-stat h2 {
  display: flex;
  justify-content: space-between;
  gap: var(--space-4);
  margin-bottom: var(--space-1);
}
.recovery-stat svg {
  color: var(--interactive-default);
  width: 20px;
  height: 20px;
}
.recovery-stat > strong {
  font-family: var(--font-family-mono);
  font-size: var(--font-size-h3);
  line-height: 1.5;
  overflow-wrap: anywhere;
}
.recovery-stat p {
  font-size: var(--font-size-caption-md);
  color: var(--text-secondary);
}
.recovery-tabs {
  display: flex;
  border-bottom: 1px solid var(--border-default);
  gap: var(--space-6);
  overflow-x: auto;
}
.recovery-tabs button {
  white-space: nowrap;
  padding: var(--space-3) var(--space-3) var(--space-4);
  border: 0;
  border-bottom: 2px solid transparent;
  color: var(--text-secondary);
  background: transparent;
}
.recovery-tabs button.is-active {
  color: var(--interactive-default);
  border-bottom-color: var(--interactive-default);
  font-weight: var(--font-weight-medium);
}
.recovery-workspace {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: var(--space-6);
  align-items: start;
}
.recovery-workspace.has-selection {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: start;
}
.recovery-workspace.has-selection .recovery-case-list {
  height: min(624px, calc(100vh - 386px));
  max-height: min(624px, calc(100vh - 386px));
}
.recovery-register {
  display: grid;
  gap: var(--space-4);
  min-width: 0;
}
.recovery-register > .search-field,
.recovery-register > div:first-child {
  max-width: 100%;
}
.recovery-case-list {
  background: var(--surface-primary);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-lg);
  max-height: min(680px, calc(100vh - 330px));
  min-height: 320px;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-gutter: stable;
}
.recovery-case-list > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  padding: var(--space-4);
  min-height: 55px;
  position: sticky;
  top: 0;
  z-index: 2;
  background: var(--surface-primary);
}
.recovery-case-list > header h2 {
  font-size: var(--font-size-body-sm);
}
.recovery-case-list > header span {
  color: var(--text-secondary);
  font-size: var(--font-size-caption-md);
}
.recovery-list-head {
  display: flex;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-3) var(--space-4);
  background: var(--surface-secondary);
  font-size: var(--font-size-caption-md);
  color: var(--text-secondary);
  position: sticky;
  top: 55px;
  z-index: 2;
}
.recovery-case-list .recovery-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  width: 100%;
  gap: var(--space-4);
  padding: var(--space-4);
  border: 0;
  border-bottom: 1px solid var(--border-subtle);
  border-left: 2px solid transparent;
  background: var(--surface-primary);
  color: var(--text-primary);
  text-align: left;
}
.recovery-case-list .recovery-row:hover {
  background: var(--surface-secondary);
}
.recovery-case-list .recovery-row.is-selected {
  background: var(--interactive-soft);
  border-left-color: var(--interactive-default);
}
.recovery-row > span:first-child {
  display: grid;
  gap: var(--space-1);
  padding-top: var(--space-4);
}
.recovery-row strong {
  font-weight: var(--font-weight-regular);
  overflow-wrap: anywhere;
}
.recovery-reference,
.recovery-row-balance {
  font-family: var(--font-family-mono);
}
.recovery-reference {
  color: var(--interactive-default);
}
.recovery-row-balance {
  white-space: nowrap;
}
.recovery-row-balance.is-owing {
  color: var(--danger-default);
}
.recovery-row-context {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-3);
  grid-column: 1/-1;
  margin-top: var(--space-4);
  font-size: var(--font-size-caption-md);
  color: var(--text-secondary);
}
.recovery-row > small {
  grid-column: 1/-1;
  color: var(--text-secondary);
  font-size: var(--font-size-caption-md);
}
.recovery-badge {
  display: inline-block;
  width: max-content;
  max-width: 100%;
  border-radius: var(--radius-pill);
  padding: var(--space-1) var(--space-2);
  font-size: var(--font-size-caption-sm);
  font-weight: var(--font-weight-medium);
  background: var(--surface-tertiary);
  color: var(--text-primary);
}
.recovery-badge.is-review {
  background: var(--warning-soft);
  color: var(--warning-text);
}
.recovery-badge.is-closed {
  background: var(--success-soft);
  color: var(--success-text);
}
.recovery-case-list > footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-4);
  font-size: var(--font-size-caption-md);
  color: var(--text-secondary);
  position: sticky;
  bottom: 0;
  z-index: 2;
  border-top: 1px solid var(--border-subtle);
  background: var(--surface-primary);
}
.recovery-case-list > footer > div {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}
.recovery-pagination > span {
  min-width: 78px;
  text-align: center;
  white-space: nowrap;
}
.recovery-case-list > footer button {
  background: var(--surface-primary);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-sm);
  padding: var(--space-1);
  color: var(--text-primary);
}
.recovery-notice {
  display: flex;
  align-items: start;
  gap: var(--space-3);
  padding: var(--space-4);
  border-radius: var(--radius-lg);
  color: var(--warning-text);
  background: var(--warning-soft);
  font-size: var(--font-size-caption-md);
}
.recovery-notice > svg {
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
}
.recovery-notice p {
  margin-top: var(--space-1);
}
.recovery-notice button {
  border: 1px solid var(--warning-border);
  border-radius: var(--radius-sm);
  background: var(--surface-primary);
  color: var(--text-primary);
  padding: var(--space-2);
}
.recovery-case {
  background: var(--surface-primary);
  box-shadow: var(--elevation-medium);
  min-width: 0;
}
.recovery-case > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-6);
  border-bottom: 1px solid var(--border-default);
}
.recovery-case > header button,
.recovery-modal > header button {
  display: grid;
  place-items: center;
  border: 0;
  background: transparent;
  color: var(--text-primary);
  width: 32px;
  height: 32px;
  border-radius: var(--radius-sm);
}
.recovery-case-body {
  padding: var(--space-6);
  display: grid;
  gap: var(--space-4);
}
.recovery-case-status {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-3);
  flex-wrap: wrap;
}
.recovery-case-status a {
  font-family: var(--font-family-mono);
}
.recovery-case-facts {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: var(--space-4);
  margin: 0;
  font-size: var(--font-size-body-sm);
}
.recovery-case-facts dt {
  color: var(--text-secondary);
}
.recovery-case-facts dd {
  margin: 0;
  text-align: right;
  font-family: var(--font-family-mono);
  overflow-wrap: anywhere;
}
.recovery-next {
  padding: var(--space-4);
  background: var(--interactive-soft);
  border-radius: var(--radius-md);
  display: grid;
  gap: var(--space-3);
}
.recovery-next > strong {
  color: var(--interactive-default);
  font-size: var(--font-size-body-sm);
}
.recovery-next p {
  color: var(--text-secondary);
  font-size: var(--font-size-body-sm);
}
.recovery-shell .recovery-primary {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-height: 40px;
  padding: var(--space-2) var(--space-4);
  border: 1px solid var(--interactive-default);
  border-radius: var(--radius-md);
  background: var(--interactive-default);
  color: var(--on-interactive-primary);
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-label-md);
  text-decoration: none;
}
.recovery-shell .recovery-secondary {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-height: 40px;
  padding: var(--space-2) var(--space-3);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  background: var(--surface-primary);
  color: var(--text-primary);
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-label-md);
  text-decoration: none;
}
.recovery-shell .recovery-secondary:hover {
  background: var(--surface-secondary);
}
.recovery-shell .recovery-primary:hover {
  background: var(--interactive-hover);
}
.recovery-automation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-3);
  font-size: var(--font-size-caption-md);
}
.recovery-automation > div {
  display: grid;
  gap: var(--space-1);
}
.recovery-automation small {
  color: var(--text-secondary);
  font-size: var(--font-size-caption-md);
}
.recovery-switch {
  position: relative;
  display: flex;
  align-items: center;
  gap: var(--space-2);
}
.recovery-switch input {
  position: absolute;
  left: 0;
  width: 32px;
  height: 20px;
  opacity: 0;
  cursor: pointer;
}
.recovery-switch > span {
  display: block;
  width: 32px;
  height: 18px;
  background: var(--border-strong);
  border-radius: var(--radius-pill);
  padding: 2px;
}
.recovery-switch > span::before {
  content: "";
  display: block;
  width: 14px;
  height: 14px;
  border-radius: var(--radius-pill);
  background: var(--on-interactive-primary);
}
.recovery-switch input:checked + span {
  background: var(--interactive-default);
}
.recovery-switch input:checked + span::before {
  transform: translateX(14px);
}
.recovery-switch input:focus-visible + span {
  outline: 2px solid var(--focus-ring);
  outline-offset: 3px;
}
.recovery-case-actions {
  display: flex;
  gap: var(--space-2);
  flex-wrap: wrap;
}
.recovery-dispute {
  display: flex;
  gap: var(--space-2);
  align-items: center;
  color: var(--text-secondary);
  font-size: var(--font-size-caption-md);
}
.recovery-timeline {
  display: grid;
  gap: var(--space-4);
  list-style: none;
  margin: 0;
  padding: 0;
}
.recovery-timeline li {
  border-left: 2px solid var(--border-default);
  padding-left: var(--space-3);
  display: grid;
  gap: var(--space-1);
  font-size: var(--font-size-caption-md);
}
.recovery-timeline time {
  font-size: var(--font-size-caption-sm);
  color: var(--text-secondary);
}
.recovery-timeline p {
  color: var(--text-secondary);
}
.recovery-timeline strong {
  font-weight: var(--font-weight-medium);
}
.recovery-case > footer {
  padding: var(--space-4) var(--space-6);
  border-top: 1px solid var(--border-default);
  color: var(--text-secondary);
  font-family: var(--font-family-mono);
  text-align: right;
  font-size: var(--font-size-caption-md);
}
.recovery-empty {
  padding: var(--space-8) var(--space-4);
  color: var(--text-secondary);
}
.recovery-error {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
  align-items: center;
  background: var(--danger-soft);
  color: var(--danger-text);
  padding: var(--space-4);
  border-radius: var(--radius-md);
}
.recovery-error button {
  display: inline-flex;
  gap: var(--space-2);
  align-items: center;
  background: var(--surface-primary);
  color: var(--text-primary);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-sm);
  padding: var(--space-2);
}
.recovery-success {
  display: flex;
  gap: var(--space-3);
  align-items: center;
  background: var(--success-soft);
  color: var(--success-text);
  padding: var(--space-4);
  border-radius: var(--radius-md);
}
.recovery-breadcrumb {
  display: flex;
  gap: var(--space-3);
  align-items: center;
  flex-wrap: wrap;
  font-size: var(--font-size-body-sm);
  color: var(--text-secondary);
}
.recovery-breadcrumb a {
  color: var(--text-secondary);
}
.recovery-demand-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.65fr) minmax(300px, 1fr);
  gap: var(--space-6);
  align-items: start;
}
.recovery-panel {
  padding: var(--space-6);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-lg);
  background: var(--surface-primary);
  display: grid;
  gap: var(--space-5);
  min-width: 0;
}
.recovery-demand-aside {
  display: grid;
  gap: var(--space-4);
  min-width: 0;
}
.recovery-loading-layout {
  display: grid;
  gap: var(--space-6);
}
.recovery-loading-context {
  min-height: 24px;
}
.recovery-loading-stat > :is(strong, p) {
  width: 100%;
}
.recovery-loading-tabs {
  min-height: 45px;
}
.recovery-loading-tabs button {
  opacity: 1;
}
.recovery-loading-search .app-skeleton:last-child {
  max-width: calc(100% - 26px);
}
.recovery-loading-row {
  cursor: default;
}
.recovery-loading-row > span:first-child {
  display: grid;
  gap: var(--space-2);
}
.recovery-loading-row .recovery-row-balance {
  width: 72px;
}
.recovery-loading-case {
  overflow: hidden;
}
.recovery-loading-case .recovery-loading-facts,
.recovery-loading-facts {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-4);
}
.recovery-loading-case > footer .app-skeleton {
  margin-left: auto;
}
.recovery-loading-letter {
  min-height: 520px;
  align-content: start;
}
.recovery-loading-copy {
  display: grid;
  gap: var(--space-4);
  margin-top: var(--space-4);
}
.recovery-loading-attachment {
  margin-top: var(--space-4);
}
.recovery-loading-confirm,
.recovery-loading-approval {
  align-content: start;
}
.recovery-loading-notice > div {
  display: grid;
  flex: 1 1;
  gap: var(--space-2);
}
.recovery-letter-brand {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-3);
}
.recovery-letter-text {
  display: grid;
  gap: var(--space-5);
  white-space: pre-line;
  overflow-wrap: anywhere;
  line-height: 1.7;
}
.recovery-letter-text > p:nth-child(2) {
  font-size: var(--font-size-h3);
  font-weight: var(--font-weight-medium);
}
.recovery-attachment-note {
  margin-top: var(--space-4) !important;
  color: var(--text-secondary);
}
.recovery-shell
  label:not(.recovery-check, .recovery-dispute, .recovery-switch) {
  display: grid;
  gap: var(--space-2);
  font-size: var(--font-size-body-sm);
  font-weight: var(--font-weight-medium);
}
.recovery-shell :is(input:not([type="checkbox"]), textarea) {
  font-family: inherit;
  font-size: var(--font-size-body-sm);
  padding: var(--space-2) var(--space-3);
  min-height: 40px;
  width: 100%;
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  background: var(--surface-primary);
  color: var(--text-primary);
}
.recovery-shell input[readonly] {
  background: var(--surface-secondary);
}
.recovery-shell input[type="checkbox"] {
  accent-color: var(--interactive-default);
}
.recovery-check {
  display: flex;
  align-items: start;
  gap: var(--space-2);
  font-weight: var(--font-weight-regular);
}
.recovery-check input {
  margin-top: 4px;
  flex-shrink: 0;
}
.recovery-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1450;
  background: var(--overlay-default);
  display: grid;
  place-items: center;
  padding: var(--space-5);
}
.recovery-modal {
  width: min(560px, 100%);
  max-height: calc(100dvh - 40px);
  display: flex;
  flex-direction: column;
  background: var(--surface-primary);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-lg);
  box-shadow: var(--elevation-large);
}
.recovery-modal > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-5) var(--space-6);
  border-bottom: 1px solid var(--border-default);
}
.recovery-modal > form {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.recovery-modal-body {
  display: grid;
  gap: var(--space-5);
  padding: var(--space-6);
  overflow-y: auto;
}
.recovery-modal form > footer {
  padding: var(--space-4) var(--space-6);
  display: flex;
  justify-content: flex-end;
  gap: var(--space-3);
  border-top: 1px solid var(--border-default);
}
@media (max-width: 1100px) {
  .recovery-tabs {
    gap: var(--space-4);
  }
  .recovery-workspace.has-selection {
    grid-template-columns: minmax(0, 1fr) minmax(300px, 1fr);
  }
}
@media (max-width: 1024px) {
  .recovery-main {
    margin-left: 0;
  }
  .recovery-page {
    padding: var(--space-6);
  }
  .recovery-shell h1 {
    font-size: 28px;
    line-height: 35px;
    letter-spacing: -0.42px;
  }
}
@media (max-width: 760px) {
  .recovery-page {
    padding: var(--space-4);
  }
  .recovery-shell h1 {
    font-size: 24px;
    line-height: 30px;
    letter-spacing: -0.36px;
  }
  .recovery-stats,
  .recovery-demand-grid,
  .recovery-workspace.has-selection {
    grid-template-columns: minmax(0, 1fr);
  }
  .recovery-stats {
    gap: var(--space-4);
  }
  .recovery-stat {
    min-height: 0;
    padding: var(--space-5);
  }
  .recovery-case-list {
    max-height: min(620px, calc(100vh - 220px));
    min-height: 280px;
  }
  .recovery-workspace.has-selection .recovery-case-list {
    height: auto;
    max-height: min(620px, calc(100vh - 220px));
  }
  .recovery-case {
    box-shadow: none;
    border: 1px solid var(--border-default);
    border-radius: var(--radius-lg);
    overflow: hidden;
  }
  .recovery-case > header,
  .recovery-case-body {
    padding: var(--space-5);
  }
  .recovery-modal-backdrop {
    padding: var(--space-3);
  }
  .recovery-modal {
    max-height: calc(100dvh - 24px);
  }
  .recovery-modal > header,
  .recovery-modal-body {
    padding: var(--space-5);
  }
  .recovery-panel {
    padding: var(--space-5);
  }
  .recovery-tabs {
    gap: var(--space-2);
  }
  .recovery-tabs button {
    padding-left: var(--space-2);
    padding-right: var(--space-2);
  }
}
.recovery-search {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  background: var(--surface-primary);
  padding: 0 var(--space-3);
  min-height: 40px;
  color: var(--text-secondary);
}
.recovery-search > svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
.recovery-shell .recovery-search input {
  padding: 0;
  border: 0;
  background: transparent;
  min-width: 0;
  flex: 1 1;
  outline: none;
}
.recovery-search:focus-within {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}
.recovery-shell {
  letter-spacing: normal;
}
.recovery-stat h2 {
  font-size: var(--font-size-body-md);
}
.recovery-stat {
  gap: var(--space-2);
}
.recovery-shell .figma-datepicker-root {
  width: 100%;
}
.recovery-shell .figma-datepicker__input {
  padding: 0;
  min-height: 0;
  border: 0;
  background: transparent;
}

/* Keep the case workspace usable before the persistent sidebar disappears. */
@media (min-width: 1025px) and (max-width: 1360px), (max-width: 960px) {
  .recovery-workspace.has-selection,
  .recovery-demand-grid { grid-template-columns: minmax(0, 1fr); }
}
.recovery-shell :is(header, footer, section, aside, label, form),
.recovery-modal :is(header, footer, label, form) { min-width: 0; }
.recovery-shell :is(h1, h2, h3, p, a, dd),
.recovery-modal :is(h2, p, label) { overflow-wrap: anywhere; }
.recovery-tabs button { flex-shrink: 0; }
.recovery-tabs { overscroll-behavior-x: contain; }
.recovery-case-list > header,
.recovery-case-list > footer,
.recovery-case-actions,
.recovery-letter-brand { flex-wrap: wrap; }
.recovery-row > span { min-width: 0; }
.recovery-modal { min-width: 0; box-sizing: border-box; }
.recovery-modal > header { flex-shrink: 0; }
.recovery-modal > form { min-height: 0; }
.recovery-modal-body { min-height: 0; overscroll-behavior-y: contain; }
.recovery-modal form > footer { flex-shrink: 0; flex-wrap: wrap; }
.recovery-modal :is(input:not([type=checkbox]):not([type=radio]), textarea, select) {
  min-width: 0; max-width: 100%; box-sizing: border-box;
}
@media (max-width: 600px) {
  .recovery-case-list > footer { gap: var(--space-3); }
  .recovery-case-list > footer > div { flex-wrap: wrap; }
  .recovery-case-actions > :is(button, a),
  .recovery-modal form > footer > button {
    flex: 1 1 140px; min-height: 40px; height: auto; white-space: normal;
  }
  .recovery-modal form > footer { padding: var(--space-4); }
  .recovery-modal > header,
  .recovery-modal-body { padding: var(--space-4); }
}
@media (max-width: 420px) {
  .recovery-case-list .recovery-row { grid-template-columns: minmax(0, 1fr); gap: var(--space-2); }
  .recovery-row-balance { white-space: normal; overflow-wrap: anywhere; }
  .recovery-case-facts { grid-template-columns: minmax(0, 1fr); gap: var(--space-2); }
  .recovery-case-facts dd { text-align: left; margin-bottom: var(--space-3); }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/Recovery/recovery.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,0BAA0B;EAC1B,uCAAuC;EACvC,mCAAmC;EACnC,iBAAiB;AACnB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,wCAAwC;AAC1C;AACA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;;;EAGE,4BAA4B;AAC9B;AACA;;EAEE,iCAAiC;EACjC,qBAAqB;AACvB;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;AACxC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;AACrB;AACA;EACE,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;EACvB,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,iCAAiC;EACjC,WAAW;EACX,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,sCAAsC;EACtC,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,8CAA8C;EAC9C,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,qDAAqD;EACrD,SAAS;EACT,oCAAoC;EACpC,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,iCAAiC;EACjC,+CAA+C;EAC/C,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gDAAgD;EAChD,kBAAkB;AACpB;AACA;EACE,uCAAuC;EACvC,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;;EAEE,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,+BAA+B;EAC/B,2CAA2C;EAC3C,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,kCAAkC;AACpC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,4BAA4B;EAC5B,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sCAAsC;EACtC,oCAAoC;EACpC,sCAAsC;EACtC,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,6CAA6C;EAC7C,kCAAkC;EAClC,kCAAkC;EAClC,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,mCAAmC;EACnC,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,uCAAuC;EACvC,uBAAuB;AACzB;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;EAC1B,sCAAsC;EACtC,4BAA4B;AAC9B;AACA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,sCAAsC;AACxC;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;EACtC,mCAAmC;EACnC,0BAA0B;AAC5B;AACA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,0CAA0C;EAC1C,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,0BAA0B;EAC1B,+BAA+B;EAC/B,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,uCAAuC;EACvC,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;EAC1B,uBAAuB;AACzB;AACA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,8CAA8C;AAChD;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,oDAAoD;EACpD,mBAAmB;EACnB,SAAS;EACT,mCAAmC;AACrC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,oCAAoC;EACpC,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,mCAAmC;AACrC;AACA;EACE,4BAA4B;EAC5B,mCAAmC;AACrC;AACA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,4CAA4C;EAC5C,+BAA+B;EAC/B,sCAAsC;EACtC,oCAAoC;EACpC,sCAAsC;EACtC,oCAAoC;EACpC,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,uCAAuC;EACvC,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;EAC1B,sCAAsC;EACtC,oCAAoC;EACpC,qBAAqB;AACvB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,iCAAiC;EACjC,YAAY;AACd;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,yCAAyC;AAC3C;AACA;EACE,sCAAsC;AACxC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,4CAA4C;EAC5C,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,sCAAsC;AACxC;AACA;EACE,sCAAsC;EACtC,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;EACtC,2CAA2C;EAC3C,4BAA4B;EAC5B,oCAAoC;EACpC,iBAAiB;EACjB,sCAAsC;AACxC;AACA;EACE,sCAAsC;EACtC,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,kCAAkC;EAClC,0BAA0B;EAC1B,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;EAC1B,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,mCAAmC;EACnC,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,2DAA2D;EAC3D,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,uCAAuC;EACvC,+BAA+B;EAC/B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,SAAO;EACP,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,sCAAsC;AACxC;AACA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,sCAAsC;AACxC;AACA;EACE,oBAAoB;EACpB,mCAAmC;EACnC,sCAAsC;EACtC,gBAAgB;EAChB,WAAW;EACX,uCAAuC;EACvC,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;AACzC;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,uCAAuC;EACvC,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,sCAAsC;EACtC,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,sCAAsC;EACtC,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,wDAAwD;EAC1D;AACF;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,uBAAuB;EACzB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,uBAAuB;EACzB;EACA;;;IAGE,qCAAqC;EACvC;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,2CAA2C;IAC3C,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,2CAA2C;EAC7C;EACA;IACE,gBAAgB;IAChB,uCAAuC;IACvC,+BAA+B;IAC/B,gBAAgB;EAClB;EACA;;IAEE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,+BAA+B;EACjC;EACA;;IAEE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uCAAuC;EACvC,+BAA+B;EAC/B,kCAAkC;EAClC,yBAAyB;EACzB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,SAAO;EACP,aAAa;AACf;AACA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA,6EAA6E;AAC7E;EACE;0BACwB,qCAAqC,EAAE;AACjE;AACA;mDACmD,YAAY,EAAE;AACjE;oCACoC,uBAAuB,EAAE;AAC7D,wBAAwB,cAAc,EAAE;AACxC,iBAAiB,8BAA8B,EAAE;AACjD;;;yBAGyB,eAAe,EAAE;AAC1C,uBAAuB,YAAY,EAAE;AACrC,kBAAkB,YAAY,EAAE,sBAAsB,EAAE;AACxD,2BAA2B,cAAc,EAAE;AAC3C,yBAAyB,aAAa,EAAE;AACxC,uBAAuB,aAAa,EAAE,8BAA8B,EAAE;AACtE,gCAAgC,cAAc,EAAE,eAAe,EAAE;AACjE;EACE,YAAY,EAAE,eAAe,EAAE,sBAAsB;AACvD;AACA;EACE,+BAA+B,mBAAmB,EAAE;EACpD,qCAAqC,eAAe,EAAE;EACtD;;IAEE,eAAe,EAAE,gBAAgB,EAAE,YAAY,EAAE,mBAAmB;EACtE;EACA,gCAAgC,uBAAuB,EAAE;EACzD;yBACuB,uBAAuB,EAAE;AAClD;AACA;EACE,oCAAoC,qCAAqC,EAAE,mBAAmB,EAAE;EAChG,wBAAwB,mBAAmB,EAAE,uBAAuB,EAAE;EACtE,uBAAuB,qCAAqC,EAAE,mBAAmB,EAAE;EACnF,0BAA0B,gBAAgB,EAAE,6BAA6B,EAAE;AAC7E","sourcesContent":[".recovery-shell {\n  min-height: 100vh;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  font-family: var(--font-family-primary);\n  font-size: var(--font-size-body-sm);\n  line-height: 1.55;\n}\n.recovery-shell * {\n  box-sizing: border-box;\n}\n.recovery-main {\n  margin-left: 256px;\n  min-width: 0;\n}\n.recovery-page {\n  padding: var(--space-8);\n  max-width: 1600px;\n  margin: 0 auto;\n  display: grid;\n  gap: var(--space-6);\n  min-width: 0;\n}\n.recovery-shell :is(h1, h2, h3, p) {\n  margin: 0;\n}\n.recovery-shell h1 {\n  font-size: 32px;\n  line-height: 40px;\n  letter-spacing: -0.48px;\n  font-weight: var(--font-weight-semibold);\n}\n.recovery-shell h2 {\n  font-size: var(--font-size-h4);\n  font-weight: var(--font-weight-medium);\n  line-height: 1.5;\n}\n.recovery-shell h3 {\n  font-size: var(--font-size-body-md);\n  font-weight: var(--font-weight-medium);\n  line-height: 1.5;\n}\n.recovery-heading {\n  display: grid;\n  gap: var(--space-2);\n}\n.recovery-heading p,\n.recovery-context,\n.recovery-panel > p {\n  color: var(--text-secondary);\n}\n.recovery-page a,\n.recovery-modal a {\n  color: var(--interactive-default);\n  text-decoration: none;\n}\n.recovery-page a:hover,\n.recovery-modal a:hover {\n  text-decoration: underline;\n}\n.recovery-shell button {\n  font: inherit;\n  cursor: pointer;\n}\n.recovery-shell button:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n.recovery-shell :focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 3px;\n}\n.recovery-context {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--space-4);\n  font-size: var(--font-size-caption-md);\n}\n.recovery-context > .quotation-figma-dropdown {\n  max-width: 140px;\n}\n.recovery-stats {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: var(--space-6);\n}\n.recovery-stat {\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-lg);\n  padding: var(--space-6);\n  background: var(--surface-primary);\n  display: grid;\n  gap: var(--space-3);\n  min-height: 148px;\n  align-content: start;\n  min-width: 0;\n}\n.recovery-stat h2 {\n  display: flex;\n  justify-content: space-between;\n  gap: var(--space-4);\n  margin-bottom: var(--space-1);\n}\n.recovery-stat svg {\n  color: var(--interactive-default);\n  width: 20px;\n  height: 20px;\n}\n.recovery-stat > strong {\n  font-family: var(--font-family-mono);\n  font-size: var(--font-size-h3);\n  line-height: 1.5;\n  overflow-wrap: anywhere;\n}\n.recovery-stat p {\n  font-size: var(--font-size-caption-md);\n  color: var(--text-secondary);\n}\n.recovery-tabs {\n  display: flex;\n  border-bottom: 1px solid var(--border-default);\n  gap: var(--space-6);\n  overflow-x: auto;\n}\n.recovery-tabs button {\n  white-space: nowrap;\n  padding: var(--space-3) var(--space-3) var(--space-4);\n  border: 0;\n  border-bottom: 2px solid transparent;\n  color: var(--text-secondary);\n  background: transparent;\n}\n.recovery-tabs button.is-active {\n  color: var(--interactive-default);\n  border-bottom-color: var(--interactive-default);\n  font-weight: var(--font-weight-medium);\n}\n.recovery-workspace {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: var(--space-6);\n  align-items: start;\n}\n.recovery-workspace.has-selection {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  align-items: start;\n}\n.recovery-workspace.has-selection .recovery-case-list {\n  height: min(624px, calc(100vh - 386px));\n  max-height: min(624px, calc(100vh - 386px));\n}\n.recovery-register {\n  display: grid;\n  gap: var(--space-4);\n  min-width: 0;\n}\n.recovery-register > .search-field,\n.recovery-register > div:first-child {\n  max-width: 100%;\n}\n.recovery-case-list {\n  background: var(--surface-primary);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-lg);\n  max-height: min(680px, calc(100vh - 330px));\n  min-height: 320px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  scrollbar-gutter: stable;\n}\n.recovery-case-list > header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-3);\n  padding: var(--space-4);\n  min-height: 55px;\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: var(--surface-primary);\n}\n.recovery-case-list > header h2 {\n  font-size: var(--font-size-body-sm);\n}\n.recovery-case-list > header span {\n  color: var(--text-secondary);\n  font-size: var(--font-size-caption-md);\n}\n.recovery-list-head {\n  display: flex;\n  justify-content: space-between;\n  gap: var(--space-4);\n  padding: var(--space-3) var(--space-4);\n  background: var(--surface-secondary);\n  font-size: var(--font-size-caption-md);\n  color: var(--text-secondary);\n  position: sticky;\n  top: 55px;\n  z-index: 2;\n}\n.recovery-case-list .recovery-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  width: 100%;\n  gap: var(--space-4);\n  padding: var(--space-4);\n  border: 0;\n  border-bottom: 1px solid var(--border-subtle);\n  border-left: 2px solid transparent;\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  text-align: left;\n}\n.recovery-case-list .recovery-row:hover {\n  background: var(--surface-secondary);\n}\n.recovery-case-list .recovery-row.is-selected {\n  background: var(--interactive-soft);\n  border-left-color: var(--interactive-default);\n}\n.recovery-row > span:first-child {\n  display: grid;\n  gap: var(--space-1);\n  padding-top: var(--space-4);\n}\n.recovery-row strong {\n  font-weight: var(--font-weight-regular);\n  overflow-wrap: anywhere;\n}\n.recovery-reference,\n.recovery-row-balance {\n  font-family: var(--font-family-mono);\n}\n.recovery-reference {\n  color: var(--interactive-default);\n}\n.recovery-row-balance {\n  white-space: nowrap;\n}\n.recovery-row-balance.is-owing {\n  color: var(--danger-default);\n}\n.recovery-row-context {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: var(--space-3);\n  grid-column: 1/-1;\n  margin-top: var(--space-4);\n  font-size: var(--font-size-caption-md);\n  color: var(--text-secondary);\n}\n.recovery-row > small {\n  grid-column: 1/-1;\n  color: var(--text-secondary);\n  font-size: var(--font-size-caption-md);\n}\n.recovery-badge {\n  display: inline-block;\n  width: max-content;\n  max-width: 100%;\n  border-radius: var(--radius-pill);\n  padding: var(--space-1) var(--space-2);\n  font-size: var(--font-size-caption-sm);\n  font-weight: var(--font-weight-medium);\n  background: var(--surface-tertiary);\n  color: var(--text-primary);\n}\n.recovery-badge.is-review {\n  background: var(--warning-soft);\n  color: var(--warning-text);\n}\n.recovery-badge.is-closed {\n  background: var(--success-soft);\n  color: var(--success-text);\n}\n.recovery-case-list > footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-4);\n  padding: var(--space-4);\n  font-size: var(--font-size-caption-md);\n  color: var(--text-secondary);\n  position: sticky;\n  bottom: 0;\n  z-index: 2;\n  border-top: 1px solid var(--border-subtle);\n  background: var(--surface-primary);\n}\n.recovery-case-list > footer > div {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n}\n.recovery-pagination > span {\n  min-width: 78px;\n  text-align: center;\n  white-space: nowrap;\n}\n.recovery-case-list > footer button {\n  background: var(--surface-primary);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-sm);\n  padding: var(--space-1);\n  color: var(--text-primary);\n}\n.recovery-notice {\n  display: flex;\n  align-items: start;\n  gap: var(--space-3);\n  padding: var(--space-4);\n  border-radius: var(--radius-lg);\n  color: var(--warning-text);\n  background: var(--warning-soft);\n  font-size: var(--font-size-caption-md);\n}\n.recovery-notice > svg {\n  width: 20px;\n  height: 20px;\n  flex: 0 0 20px;\n}\n.recovery-notice p {\n  margin-top: var(--space-1);\n}\n.recovery-notice button {\n  border: 1px solid var(--warning-border);\n  border-radius: var(--radius-sm);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  padding: var(--space-2);\n}\n.recovery-case {\n  background: var(--surface-primary);\n  box-shadow: var(--elevation-medium);\n  min-width: 0;\n}\n.recovery-case > header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--space-6);\n  border-bottom: 1px solid var(--border-default);\n}\n.recovery-case > header button,\n.recovery-modal > header button {\n  display: grid;\n  place-items: center;\n  border: 0;\n  background: transparent;\n  color: var(--text-primary);\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-sm);\n}\n.recovery-case-body {\n  padding: var(--space-6);\n  display: grid;\n  gap: var(--space-4);\n}\n.recovery-case-status {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--space-3);\n  flex-wrap: wrap;\n}\n.recovery-case-status a {\n  font-family: var(--font-family-mono);\n}\n.recovery-case-facts {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  gap: var(--space-4);\n  margin: 0;\n  font-size: var(--font-size-body-sm);\n}\n.recovery-case-facts dt {\n  color: var(--text-secondary);\n}\n.recovery-case-facts dd {\n  margin: 0;\n  text-align: right;\n  font-family: var(--font-family-mono);\n  overflow-wrap: anywhere;\n}\n.recovery-next {\n  padding: var(--space-4);\n  background: var(--interactive-soft);\n  border-radius: var(--radius-md);\n  display: grid;\n  gap: var(--space-3);\n}\n.recovery-next > strong {\n  color: var(--interactive-default);\n  font-size: var(--font-size-body-sm);\n}\n.recovery-next p {\n  color: var(--text-secondary);\n  font-size: var(--font-size-body-sm);\n}\n.recovery-shell .recovery-primary {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 40px;\n  padding: var(--space-2) var(--space-4);\n  border: 1px solid var(--interactive-default);\n  border-radius: var(--radius-md);\n  background: var(--interactive-default);\n  color: var(--on-interactive-primary);\n  font-weight: var(--font-weight-medium);\n  font-size: var(--font-size-label-md);\n  text-decoration: none;\n}\n.recovery-shell .recovery-secondary {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 40px;\n  padding: var(--space-2) var(--space-3);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  font-weight: var(--font-weight-medium);\n  font-size: var(--font-size-label-md);\n  text-decoration: none;\n}\n.recovery-shell .recovery-secondary:hover {\n  background: var(--surface-secondary);\n}\n.recovery-shell .recovery-primary:hover {\n  background: var(--interactive-hover);\n}\n.recovery-automation {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--space-3);\n  font-size: var(--font-size-caption-md);\n}\n.recovery-automation > div {\n  display: grid;\n  gap: var(--space-1);\n}\n.recovery-automation small {\n  color: var(--text-secondary);\n  font-size: var(--font-size-caption-md);\n}\n.recovery-switch {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n}\n.recovery-switch input {\n  position: absolute;\n  left: 0;\n  width: 32px;\n  height: 20px;\n  opacity: 0;\n  cursor: pointer;\n}\n.recovery-switch > span {\n  display: block;\n  width: 32px;\n  height: 18px;\n  background: var(--border-strong);\n  border-radius: var(--radius-pill);\n  padding: 2px;\n}\n.recovery-switch > span::before {\n  content: \"\";\n  display: block;\n  width: 14px;\n  height: 14px;\n  border-radius: var(--radius-pill);\n  background: var(--on-interactive-primary);\n}\n.recovery-switch input:checked + span {\n  background: var(--interactive-default);\n}\n.recovery-switch input:checked + span::before {\n  transform: translateX(14px);\n}\n.recovery-switch input:focus-visible + span {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 3px;\n}\n.recovery-case-actions {\n  display: flex;\n  gap: var(--space-2);\n  flex-wrap: wrap;\n}\n.recovery-dispute {\n  display: flex;\n  gap: var(--space-2);\n  align-items: center;\n  color: var(--text-secondary);\n  font-size: var(--font-size-caption-md);\n}\n.recovery-timeline {\n  display: grid;\n  gap: var(--space-4);\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.recovery-timeline li {\n  border-left: 2px solid var(--border-default);\n  padding-left: var(--space-3);\n  display: grid;\n  gap: var(--space-1);\n  font-size: var(--font-size-caption-md);\n}\n.recovery-timeline time {\n  font-size: var(--font-size-caption-sm);\n  color: var(--text-secondary);\n}\n.recovery-timeline p {\n  color: var(--text-secondary);\n}\n.recovery-timeline strong {\n  font-weight: var(--font-weight-medium);\n}\n.recovery-case > footer {\n  padding: var(--space-4) var(--space-6);\n  border-top: 1px solid var(--border-default);\n  color: var(--text-secondary);\n  font-family: var(--font-family-mono);\n  text-align: right;\n  font-size: var(--font-size-caption-md);\n}\n.recovery-empty {\n  padding: var(--space-8) var(--space-4);\n  color: var(--text-secondary);\n}\n.recovery-error {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-3);\n  align-items: center;\n  background: var(--danger-soft);\n  color: var(--danger-text);\n  padding: var(--space-4);\n  border-radius: var(--radius-md);\n}\n.recovery-error button {\n  display: inline-flex;\n  gap: var(--space-2);\n  align-items: center;\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-sm);\n  padding: var(--space-2);\n}\n.recovery-success {\n  display: flex;\n  gap: var(--space-3);\n  align-items: center;\n  background: var(--success-soft);\n  color: var(--success-text);\n  padding: var(--space-4);\n  border-radius: var(--radius-md);\n}\n.recovery-breadcrumb {\n  display: flex;\n  gap: var(--space-3);\n  align-items: center;\n  flex-wrap: wrap;\n  font-size: var(--font-size-body-sm);\n  color: var(--text-secondary);\n}\n.recovery-breadcrumb a {\n  color: var(--text-secondary);\n}\n.recovery-demand-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1.65fr) minmax(300px, 1fr);\n  gap: var(--space-6);\n  align-items: start;\n}\n.recovery-panel {\n  padding: var(--space-6);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-lg);\n  background: var(--surface-primary);\n  display: grid;\n  gap: var(--space-5);\n  min-width: 0;\n}\n.recovery-demand-aside {\n  display: grid;\n  gap: var(--space-4);\n  min-width: 0;\n}\n.recovery-loading-layout {\n  display: grid;\n  gap: var(--space-6);\n}\n.recovery-loading-context {\n  min-height: 24px;\n}\n.recovery-loading-stat > :is(strong, p) {\n  width: 100%;\n}\n.recovery-loading-tabs {\n  min-height: 45px;\n}\n.recovery-loading-tabs button {\n  opacity: 1;\n}\n.recovery-loading-search .app-skeleton:last-child {\n  max-width: calc(100% - 26px);\n}\n.recovery-loading-row {\n  cursor: default;\n}\n.recovery-loading-row > span:first-child {\n  display: grid;\n  gap: var(--space-2);\n}\n.recovery-loading-row .recovery-row-balance {\n  width: 72px;\n}\n.recovery-loading-case {\n  overflow: hidden;\n}\n.recovery-loading-case .recovery-loading-facts,\n.recovery-loading-facts {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--space-4);\n}\n.recovery-loading-case > footer .app-skeleton {\n  margin-left: auto;\n}\n.recovery-loading-letter {\n  min-height: 520px;\n  align-content: start;\n}\n.recovery-loading-copy {\n  display: grid;\n  gap: var(--space-4);\n  margin-top: var(--space-4);\n}\n.recovery-loading-attachment {\n  margin-top: var(--space-4);\n}\n.recovery-loading-confirm,\n.recovery-loading-approval {\n  align-content: start;\n}\n.recovery-loading-notice > div {\n  display: grid;\n  flex: 1;\n  gap: var(--space-2);\n}\n.recovery-letter-brand {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--space-3);\n}\n.recovery-letter-text {\n  display: grid;\n  gap: var(--space-5);\n  white-space: pre-line;\n  overflow-wrap: anywhere;\n  line-height: 1.7;\n}\n.recovery-letter-text > p:nth-child(2) {\n  font-size: var(--font-size-h3);\n  font-weight: var(--font-weight-medium);\n}\n.recovery-attachment-note {\n  margin-top: var(--space-4) !important;\n  color: var(--text-secondary);\n}\n.recovery-shell\n  label:not(.recovery-check, .recovery-dispute, .recovery-switch) {\n  display: grid;\n  gap: var(--space-2);\n  font-size: var(--font-size-body-sm);\n  font-weight: var(--font-weight-medium);\n}\n.recovery-shell :is(input:not([type=\"checkbox\"]), textarea) {\n  font-family: inherit;\n  font-size: var(--font-size-body-sm);\n  padding: var(--space-2) var(--space-3);\n  min-height: 40px;\n  width: 100%;\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n}\n.recovery-shell input[readonly] {\n  background: var(--surface-secondary);\n}\n.recovery-shell input[type=\"checkbox\"] {\n  accent-color: var(--interactive-default);\n}\n.recovery-check {\n  display: flex;\n  align-items: start;\n  gap: var(--space-2);\n  font-weight: var(--font-weight-regular);\n}\n.recovery-check input {\n  margin-top: 4px;\n  flex-shrink: 0;\n}\n.recovery-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1450;\n  background: var(--overlay-default);\n  display: grid;\n  place-items: center;\n  padding: var(--space-5);\n}\n.recovery-modal {\n  width: min(560px, 100%);\n  max-height: calc(100dvh - 40px);\n  display: flex;\n  flex-direction: column;\n  background: var(--surface-primary);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--elevation-large);\n}\n.recovery-modal > header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-4);\n  padding: var(--space-5) var(--space-6);\n  border-bottom: 1px solid var(--border-default);\n}\n.recovery-modal > form {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.recovery-modal-body {\n  display: grid;\n  gap: var(--space-5);\n  padding: var(--space-6);\n  overflow-y: auto;\n}\n.recovery-modal form > footer {\n  padding: var(--space-4) var(--space-6);\n  display: flex;\n  justify-content: flex-end;\n  gap: var(--space-3);\n  border-top: 1px solid var(--border-default);\n}\n@media (max-width: 1100px) {\n  .recovery-tabs {\n    gap: var(--space-4);\n  }\n  .recovery-workspace.has-selection {\n    grid-template-columns: minmax(0, 1fr) minmax(300px, 1fr);\n  }\n}\n@media (max-width: 1024px) {\n  .recovery-main {\n    margin-left: 0;\n  }\n  .recovery-page {\n    padding: var(--space-6);\n  }\n  .recovery-shell h1 {\n    font-size: 28px;\n    line-height: 35px;\n    letter-spacing: -0.42px;\n  }\n}\n@media (max-width: 760px) {\n  .recovery-page {\n    padding: var(--space-4);\n  }\n  .recovery-shell h1 {\n    font-size: 24px;\n    line-height: 30px;\n    letter-spacing: -0.36px;\n  }\n  .recovery-stats,\n  .recovery-demand-grid,\n  .recovery-workspace.has-selection {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .recovery-stats {\n    gap: var(--space-4);\n  }\n  .recovery-stat {\n    min-height: 0;\n    padding: var(--space-5);\n  }\n  .recovery-case-list {\n    max-height: min(620px, calc(100vh - 220px));\n    min-height: 280px;\n  }\n  .recovery-workspace.has-selection .recovery-case-list {\n    height: auto;\n    max-height: min(620px, calc(100vh - 220px));\n  }\n  .recovery-case {\n    box-shadow: none;\n    border: 1px solid var(--border-default);\n    border-radius: var(--radius-lg);\n    overflow: hidden;\n  }\n  .recovery-case > header,\n  .recovery-case-body {\n    padding: var(--space-5);\n  }\n  .recovery-modal-backdrop {\n    padding: var(--space-3);\n  }\n  .recovery-modal {\n    max-height: calc(100dvh - 24px);\n  }\n  .recovery-modal > header,\n  .recovery-modal-body {\n    padding: var(--space-5);\n  }\n  .recovery-panel {\n    padding: var(--space-5);\n  }\n  .recovery-tabs {\n    gap: var(--space-2);\n  }\n  .recovery-tabs button {\n    padding-left: var(--space-2);\n    padding-right: var(--space-2);\n  }\n}\n.recovery-search {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md);\n  background: var(--surface-primary);\n  padding: 0 var(--space-3);\n  min-height: 40px;\n  color: var(--text-secondary);\n}\n.recovery-search > svg {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n}\n.recovery-shell .recovery-search input {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  min-width: 0;\n  flex: 1;\n  outline: none;\n}\n.recovery-search:focus-within {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 2px;\n}\n.recovery-shell {\n  letter-spacing: normal;\n}\n.recovery-stat h2 {\n  font-size: var(--font-size-body-md);\n}\n.recovery-stat {\n  gap: var(--space-2);\n}\n.recovery-shell .figma-datepicker-root {\n  width: 100%;\n}\n.recovery-shell .figma-datepicker__input {\n  padding: 0;\n  min-height: 0;\n  border: 0;\n  background: transparent;\n}\n\n/* Keep the case workspace usable before the persistent sidebar disappears. */\n@media (min-width: 1025px) and (max-width: 1360px), (max-width: 960px) {\n  .recovery-workspace.has-selection,\n  .recovery-demand-grid { grid-template-columns: minmax(0, 1fr); }\n}\n.recovery-shell :is(header, footer, section, aside, label, form),\n.recovery-modal :is(header, footer, label, form) { min-width: 0; }\n.recovery-shell :is(h1, h2, h3, p, a, dd),\n.recovery-modal :is(h2, p, label) { overflow-wrap: anywhere; }\n.recovery-tabs button { flex-shrink: 0; }\n.recovery-tabs { overscroll-behavior-x: contain; }\n.recovery-case-list > header,\n.recovery-case-list > footer,\n.recovery-case-actions,\n.recovery-letter-brand { flex-wrap: wrap; }\n.recovery-row > span { min-width: 0; }\n.recovery-modal { min-width: 0; box-sizing: border-box; }\n.recovery-modal > header { flex-shrink: 0; }\n.recovery-modal > form { min-height: 0; }\n.recovery-modal-body { min-height: 0; overscroll-behavior-y: contain; }\n.recovery-modal form > footer { flex-shrink: 0; flex-wrap: wrap; }\n.recovery-modal :is(input:not([type=checkbox]):not([type=radio]), textarea, select) {\n  min-width: 0; max-width: 100%; box-sizing: border-box;\n}\n@media (max-width: 600px) {\n  .recovery-case-list > footer { gap: var(--space-3); }\n  .recovery-case-list > footer > div { flex-wrap: wrap; }\n  .recovery-case-actions > :is(button, a),\n  .recovery-modal form > footer > button {\n    flex: 1 1 140px; min-height: 40px; height: auto; white-space: normal;\n  }\n  .recovery-modal form > footer { padding: var(--space-4); }\n  .recovery-modal > header,\n  .recovery-modal-body { padding: var(--space-4); }\n}\n@media (max-width: 420px) {\n  .recovery-case-list .recovery-row { grid-template-columns: minmax(0, 1fr); gap: var(--space-2); }\n  .recovery-row-balance { white-space: normal; overflow-wrap: anywhere; }\n  .recovery-case-facts { grid-template-columns: minmax(0, 1fr); gap: var(--space-2); }\n  .recovery-case-facts dd { text-align: left; margin-bottom: var(--space-3); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
